var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 37,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.249 33.865c-2.653 1.62-3.979 2.431-5.072 2.336a3.33 3.33 0 0 1-2.391-1.342c-.651-.882-.651-2.436-.651-5.545V7.209c0-3.109 0-4.663.651-5.546A3.33 3.33 0 0 1 3.178.323c1.092-.096 2.418.714 5.071 2.335l18.086 11.053c2.462 1.504 3.693 2.256 4.113 3.225a3.33 3.33 0 0 1 0 2.65c-.42.97-1.65 1.722-4.113 3.226z",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;